import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "@/lib/http";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/hologram-club/login", { replace: true });
        return;
      }
      const session_id = match[1];
      try {
        const { data } = await http.post("/auth/google", { session_id });
        setUser(data);
        window.history.replaceState(null, "", "/hologram-club");
        toast.success(`Signed in as ${data.name}`);
        navigate("/hologram-club/my-reservations", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed.");
        navigate("/hologram-club/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="font-mono-ui text-xs tracking-[0.28em] uppercase text-[#00E5FF] flex items-center gap-3">
        <span className="ring-dot" /> Authenticating transmission…
      </div>
    </div>
  );
}
